import { useState } from 'react';
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
} from '@chakra-ui/react';
import { updateKycStatus } from 'api/internaltools';
import { KYB_STATUS_OPTIONS } from 'constants/kyc';
import { showError, showToast } from 'utils/notifications';

export default function UpdateKybStatusModal({ isOpen, onClose, entityId, currentStatus, onStatusUpdated }) {
  const [loading, setLoading] = useState(false);
  const [statusValue, setStatusValue] = useState('');

  const toast = useToast();

  const statusOptions = KYB_STATUS_OPTIONS.filter((option) => option.value !== currentStatus);

  const handleUpdateStatus = async () => {
    setLoading(true);

    try {
      await updateKycStatus({ status: statusValue }, entityId);
      showToast(toast, 'KYB status updated', 'KYB status has been updated successfully.', 'success');
      onStatusUpdated?.(statusValue);
      onClose();
    } catch (error) {
      showError(
        toast,
        'Error updating KYB status',
        error?.response?.data?.message || 'An error occurred while updating KYB status.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={true} size='xl' isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Update Internal KYB Status</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel color='gray.500' fontWeight='bold'>
              KYB Status
            </FormLabel>
            <Select
              value={statusValue}
              onChange={(e) => setStatusValue(e.target.value)}
              backgroundColor='white'
              placeholder='Select KYB Status'
              disabled={loading}
              color='gray.500'
            >
              {statusOptions.map((status, idx) => (
                <option key={idx} value={status.value}>
                  {status.label}
                </option>
              ))}
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Flex gap={2}>
            <Button size='sm' variant='outline' onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme='blue'
              size='sm'
              onClick={handleUpdateStatus}
              isLoading={loading}
              disabled={!statusValue || loading}
            >
              Update Status
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
